var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.namesMap && _vm.provider)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Engine: "+_vm._s(_vm.namesMap[_vm.provider]))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }